<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import Loader from "@/components/widgets/cartloader";
import { ModelListSelect } from "vue-search-select";
import { mapActions, mapGetters, mapState } from "vuex";
import Swal from "sweetalert2";
import moment from "moment";
/**
 * Form Layouts component
 */
export default {
  page: {
    title: "New Purchase",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { Layout, PageHeader, ModelListSelect,Loader, },
  data() {
    return {
      title: "Stock Consumables",
      items: [
        {
          text: "Home",
          href: "/",
        },
        {
          text: "New Purchase",
          active: true,
        },
      ],
      selected: null,
      totalRows: 1,

      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100, 200, 1000],
      filter: null,
      todoFilter: null,
      filterOn: [],
      todofilterOn: [],
      sortDesc: false,
      modal_id: "",
      fields: [
        {
          key: "index",
          sortable: true,
          label: "S/N",
        },
        {
          key: "item.name",
          sortable: true,
          label: "ITEM",
        },
        {
          key: "quantity",
          sortable: true,
          label: "QUANTITY",
        },
        {
          key: "unit_price",
          sortable: true,
          label: "UNIT PRICE",
        },
        {
          key: "batch",
          sortable: true,
          label: "BATCH",
        },
        {
          key: "expiry",
          sortable: true,
          label: "EXPIRY",
        },
        {
          sortable: false,
          key: "actions",
          label: "ACTIONS",
        },
      ],
      existingItem: [],
      unitsArr: [],

      // Value from user input for adding position
      data: {
        product: "",
        quantity: "",
        unit: "",
        unit_price: "",
        batch: "",
        expiry: "",
      },
      itemError: "",
      quantityError: "",
      priceError: "",
      PaidError:"",
      modeError:"",
      supplierError:"",
      unitError:"",
      batch_noError: "",
      expiry_dateError: "",
      contactError: "",
      nameError:"",
      totals: {
        date:moment(new Date()).format("YYYY-MM-DD"), 
        total: 0,
        paid: 0,
        mode: 0,
        supplier: "",
        discount:0,
        invoice:'',
        factory: "",
        car_plate_no: ""
      },
      // edit item
      editdata: {
        id: "",
        name: "",
        product: "",
        quantity: "",
        unit_price: "",
        batch: "",
        expiry: "",
      },
      // delete item
      deletedata: {
        name: "",
        id: "",
      },

      factorydata: {
        name: "",
        contact: "",
        location: ""
      },
    };
  },

  computed: {
    // MAP STATE
    ...mapState("notification", [
      "type",
      "message",
      "show",
    ]),
    ...mapGetters("consumables", ["SaveStatus","Consumables", "ConsumablesCart"]),
    ...mapGetters("setting", ["PaymentOptions","ReceiptSettings","GeneralSettings"]),
    ...mapGetters("auth",["MyUserPerm","branchid"]),
    ...mapGetters("stock", ["Suppliers"]),
    ...mapState("consumables", ["purchaseId"]),
    ...mapGetters("production", ["ProductionFactories"]),

    /**
     * Total no. of records
     */

    rows() {
      return this.ConsumablesCart ? this.ConsumablesCart.length : 1;
    },

    formattedFactories() {
      const factories = Array.isArray(this.ProductionFactories)
        ? this.ProductionFactories
        : Array.isArray(this.ProductionFactories?.data)
          ? this.ProductionFactories.data
          : []

      return [
        { id: '', name: 'Main Factory', location: '' },
        ...factories
      ].map(factory => ({
        ...factory,
        display_name: factory.location
          ? `${factory.name} - ${factory.location}`
          : factory.name
      }))
    },

    /**
     * Todo list of records
     */
  },
  mounted() {
    // Set the initial number of items
    this.totalRows = this.ConsumablesCart ? this.ConsumablesCart.length : 1;
  },
  methods: {
    ...mapActions({
      FetchConsumables: "consumables/fetchProductConsumables",
      FetchConsumablesCart: "consumables/fetchConsumablesCart",
      AddCart: "consumables/addToConsumableCart",
      DeleteCartItem: "consumables/deleteConsumableCart",
      EditCartItems: "consumables/editConsumableCart",
      SaveStock: "consumables/addConsumableStock",
      SaveStockPrint: "consumables/addConsumableStockPrint",
      FetchModes: "setting/fetchPaymentOptions",
      FetchSuppliers: "stock/fetchSuppliers",
      FetchGeneralSettings: "setting/fetchGeneralSettings",
      FetchReceiptSettings: "setting/fetchReceiptSettings",
      FetchProductionFactories: "production/fetchProductionFactories",
      AddProductionFactory: "production/addProductionFactory",
    }),

    // COMMA SEPERATORS
    thousandSeprator(m) {
      if (m !== "" || m !== undefined || m !== 0 || m !== "0" || m !== null) {
        return m
            .toString()
            .replace(/\D/g, "")
            .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      } else {
        return m;
      }
    },

    /**
     * Search the table data with search input
     */
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },

    addPriceCommas(){
      this.data.unit_price = this.thousandSeprator(this.data.unit_price);
    },
    editPriceCommas(){
      this.editdata.unit_price = this.thousandSeprator(this.editdata.unit_price);
    },

    checkItem() {
      if (this.data.product != "") {
        this.existingItem = this.ConsumablesCart.filter((item) => {
          return item.item.id == this.data.product;
        });
        if (this.existingItem.length) {
          this.itemError = "This Item exists already";
        } else {
          this.itemError = "";
        }
      } else {
        this.existingItem = [];
      }
    },

    resetTotals(){
      this.totals.paid = 0;
      this.totals.supplier = "";
      this.totals.factory = "";
    },

    resetData() {
      this.data.product = "";
      this.data.unit_price = "";
      this.data.unit = "";
      this.data.quantity = "";
      this.data.batch = "";
      this.data.expiry = "";
    },
    resetDeleteItem(modalId) {
      this.closeModal(modalId);
      this.deletedata.name = "";
      this.deletedata.id = "";
      this.modal_id = "";
    },
    resetEdit(modalId) {
      this.closeModal(modalId);
      this.editdata.product = "";
      this.editdata.id = "";
      this.editdata.quantity = "";
      this.editdata.unit_price = "";
      this.editdata.expiry = "";
      this.editdata.batch = "";
      this.modal_id = "";
    },

    resetErrors() {
      this.itemError = "";
      this.quantityError = "";
      this.priceError = "";
      this.unitError = "";
      this.batch_noError = "";
      this.expiry_dateError = "";
      this.contactError = "";
      this.nameError = "";
    },

    showEditModal(data) {
      this.editdata.product = data.item.id;
      this.editdata.name = data.item.name;
      this.editdata.id = data.id;
      this.editdata.quantity = data.quantity;
      this.editdata.expiry = data.expiry;
      this.editdata.batch = data.batch;
      this.editdata.unit_price = this.thousandSeprator(data.unit_price);
    },

    showDeleteModal(data) {
      this.deletedata.name = data.item.name;
      this.deletedata.id = data.id;
    },
    editItem(modalId) {
      this.modal_id = modalId;
      this.EditCartItems(this.editdata);
    },

    deleteItem(modalId) {
      this.modal_id = modalId;
      this.DeleteCartItem(this.deletedata);
    },
    saveStock() {
      if (this.totals.mode == "") {
        this.modeError = "Payment option field is required";
        return;
      } else {
        this.modeError = "";
      }
      if (this.totals.paid>0 && this.totals.paid.replaceAll(/,/g, '') <  this.totals.total.replaceAll(/,/g, '') && this.totals.supplier == "" || this.totals.paid == 0 && this.totals.supplier == "") {
        this.supplierError = "Suppier field is required";
        return;
      } else {
        this.supplierError = "";
      }
      this.SaveStock(this.totals);      
    },

    saveStockPrint(){
      if (this.totals.mode == "") {
        this.modeError = "Payment option field is required";
        return;
      } else {
        this.modeError = "";
      }
      if (this.totals.paid>0 && this.totals.paid.replaceAll(/,/g, '') <  this.totals.total.replaceAll(/,/g, '') && this.totals.supplier == "" || this.totals.paid == 0 && this.totals.supplier == "") {
        this.supplierError = "Suppier field is required";
        return;
      } else {
        this.supplierError = "";
      }
      this.SaveStockPrint(this.totals);
    },

    addToCart() {
      if (this.data.product == "") {
        this.itemError = "Product is required";
        return;
      } else {
        this.itemError = "";
      }
      if (this.data.quantity == "") {
        this.quantityError = "Quantity field is required";
        return;
      } else {
        this.quantityError = "";
      }
      if (this.data.unit_price == "") {
        this.priceError = "Unit Price Field is required";
        return;
      } else {
        this.unit_priceError = "";
      }
      if (this.data.unit == "") {
        this.unitError = "Unit Field is required";
        return;
      } else {
        this.unitError = "";
      }
      if(this.data.batch != '' && this.data.expiry == ''){
        this.expiry_dateError = 'Expiry Date is required';
        return;
      }else{
        this.expiry_dateError = "";
      }
      if(this.data.expiry != '' && this.data.batch == ''){
        this.batch_noError = 'Batch number is required';
        return;
      }else{
        this.batch_noError = "";
      }    
      if (this.existingItem.length) {
        this.itemError = "This Item exists already please";
        return;
      } else {
        this.itemError = "";
      }
      this.AddCart(this.data);
    },
    paidCommas(){
      this.totals.paid = this.thousandSeprator(this.totals.paid);
    },
    discountCommas(){
      this.totals.discount = this.thousandSeprator(this.totals.discount);
    },
    //== close modal
    closeModal(modalId) {
      this.$nextTick(() => {
        this.$bvModal.hide(modalId);
        this.resetData();
        this.resetErrors();
        this.resetFactory();
      });
    },

    setDefaultMode(){
      let defaultop = this.PaymentOptions?this.PaymentOptions:[].filter((mode)=>{
            return mode.default == 1;
        })
        this.totals.mode = defaultop[0]?defaultop[0].id:0;
    },
    resetmodeError() {
      this.modeError = "";
    },
    resetPaidError() {
      this.PaidError = "";
    },

    assignArr(){
        let selectedPdt = this.Consumables.filter((product)=>{
            return product.id == this.data.product;
        })
        this.unitsArr = selectedPdt[0].units;
        
        this.data.unit = this.unitsArr[0].id;   
        let selectedUnit = this.unitsArr.filter((unit)=>{
            return unit.id == this.data.unit;
        })     
        this.data.unit_price = this.GeneralSettings.autofillprices_onstocking == 1 && selectedUnit[0].buying?this.thousandSeprator(selectedUnit[0].buying):'';
    },
    
    assignUnitPrices(){
        let selectedUnit = this.unitsArr.filter((unit)=>{
            return unit.id == this.data.unit;
        })
        this.data.unit_price = this.GeneralSettings.autofillprices_onstocking == 1 && selectedUnit[0].buying?this.thousandSeprator(selectedUnit[0].buying):'';
    },
    
    // Validate Factory Data
    validateFactory() {
      if (this.factorydata.name != "" && this.factorydata.contact != '') {
        let faactoryData = this.ProductionFactories.filter((item) => {
          return item.contact == parseInt(this.factorydata.contact);
        })
        let factoryCount = faactoryData.length;
        if (factoryCount > 0) {
          this.contactError = "Factory with contact " + this.factorydata.contact + "  already Exists";
        }
      } else if (this.factorydata.name != "" && this.factorydata.contact == '') {
        let faactoryData = this.ProductionFactories.filter((item) => {
          return (item.name).toLowerCase() == (this.factorydata.name).toLowerCase();
        })
        let factoryCount = faactoryData.length;
        if (factoryCount > 0) {
          this.contactError = "Factory with these details already Exists";
        }
      }
    },

    resetFactory() {
      this.factorydata.contact = "";
      this.factorydata.name = "";
      this.factorydata.location = "";
    },

    addFactory(modalId) {
      this.modal_id = modalId;
      if (this.factorydata.name === "") {
        this.nameError = "Name field is required";
        return;
      } else {
        this.nameError = "";
      }
      this.validateFactory()
      if (this.contactError != "") {
        return
      }
      this.AddProductionFactory(this.factorydata);
    },
  },
  updated(){
    let total_amount = 0;
    if(this.ConsumablesCart){      
        this.ConsumablesCart.forEach((item)=>{
          total_amount = total_amount+parseInt(item.unit_price*item.quantity);      
      });
      this.totals.total = total_amount;
    }
  },

  watch: {
    ConsumablesCart(newValue){
      if(newValue == true){
        this.FetchConsumablesCart();
      }
    },
    show(newValue) {
      // Do whatever makes sense now
      if (newValue) {
        if (this.type == "success") {
          this.closeModal(this.modal_id);
          this.resetTotals();
          Swal.fire("Success!", this.message.msg, "success");
          // this.$toast.success(this.message.msg);
        } else {
          // this.$toast.error(this.message.msg);
          Swal.fire("Error!", this.message.msg, "error");
        }
      }
    },
    purchaseId(newValue) {
      if (newValue && this.ReceiptSettings.print_receipt_after_purchase == 1) {
        window.open(
          `https://${window.location.host}/receipts/purchasesreceipt.php?id=${btoa(newValue)}`
        );
      }
      this.closeModal(this.modal_id);
      this.resetTotals();
    },
  },
  created() {
    this.FetchConsumables();
    this.FetchConsumablesCart();
    this.FetchSuppliers();
    this.FetchModes();
    this.FetchGeneralSettings();
    this.FetchReceiptSettings();  
    this.FetchProductionFactories();  
    setTimeout(()=> {
         this.setDefaultMode();         
    }, 3000);
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-md-8">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title mb-4">Items in Cart</h4>
            <div class="row mt-4">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show&nbsp;
                    <b-form-select
                        class="form-select form-select-sm"
                        v-model="perPage"
                        size="sm"
                        :options="pageOptions"
                    ></b-form-select
                    >&nbsp;entries
                  </label>
                </div>
              </div>
              <!-- Search -->
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_filter" class="dataTables_filter text-md-end">
                  <label class="d-inline-flex align-items-center">
                    Search:
                    <b-form-input
                        v-model="filter"
                        type="search"
                        placeholder="Search..."
                        class="form-control form-control-sm ms-2"
                    ></b-form-input>
                  </label>
                </div>
              </div>
              <!-- End search -->
            </div>
            <!-- Table -->
            <div class="table-responsive mb-0">
              <b-table
                  class="datatables"
                  :items="ConsumablesCart ? ConsumablesCart : []"
                  :fields="fields"
                  responsive="sm"
                  :per-page="perPage"
                  :current-page="currentPage"
                  :sort-desc.sync="sortDesc"
                  :filter="filter"
                  :filter-included-fields="filterOn"
                  @filtered="onFiltered"
              >
                <template #cell(index)="data">
                  {{ data.index + 1 }}
                </template>
                <template #cell(total_price)="data">
                  {{
                    data.item.unitprice
                        ? thousandSeprator(data.item.unit_price * data.item.unit_price)
                        : 0
                  }}
                </template>

                <template #cell(unit_price)="data">
                  {{ data.item.unit_price ? thousandSeprator(data.item.unit_price) : 0 }}
                </template>
                <template #cell(quantity)="data">
                  {{ data.item ? data.item.quantity : 0 }} {{data.item.unit.unitsym}}
                </template>

                <template #cell(actions)="data">
                  <b-button
                      v-if="branchid != 0"
                      size="sm"
                      variant="primary"
                      v-b-modal.edit-item-modal
                      class="m-2"
                      @click="showEditModal(data.item)"
                  ><i class="fa fa-edit"></i></b-button
                  >
                  <b-button
                      v-if="branchid != 0"
                      v-b-modal.delete-item-modal
                      variant="danger"
                      size="sm"
                      @click="showDeleteModal(data.item)"
                  ><i class="fa fa-trash"></i></b-button
                  >
                </template>
              </b-table>

              <div class="row">
                <div class="col">
                  <div class="dataTables_paginate paging_simple_numbers float-end">
                    <ul class="pagination pagination-rounded mb-0">
                      <!-- pagination -->
                      <b-pagination
                          v-model="currentPage"
                          :total-rows="rows"
                          :per-page="perPage"
                      ></b-pagination>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <Loader v-if="!ConsumablesCart" />
            <div class="row" v-if="totals.total > 0">
              <div class="col-12 text-center mt-4">
                <h4>
                  <strong
                  >TOTAL:
                    {{
                      thousandSeprator(totals.total)
                    }}/=</strong
                  >
                </h4>
              </div>
            </div>

            <b-form v-if="totals.total > 0">              
              <div class="row">                
                <div class="col-md-4">
                  <div class="form-group">
                    <label>Amount Paid <span class="text-danger">*</span></label>
                    <input
                      type="text"
                      class="form-control"
                      v-model="totals.paid"
                      ref="Amountpaid"
                      @input="paidCommas()"
                      @keyup.enter="saveStock()"
                      min="0"
                    />
                  </div>
                  <div class="text-danger" v-if="PaidError">
                    <em>{{ PaidError }}</em>
                  </div>
                </div>
                <div class="col-md-3" v-show="GeneralSettings.purchase_discount == 1">
                  <div class="form-group">
                    <label>Discount Received</label>
                    <input
                      type="text"
                      class="form-control"
                      v-model="totals.discount"
                      @input="discountCommas()"
                      min="0"
                    />
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="form-group">
                    <label>Payment Method <span class="text-danger">*</span></label>
                    <model-list-select
                      :list="PaymentOptions ? PaymentOptions : []"
                      v-model="totals.mode"
                      option-value="id"
                      option-text="mode"
                      placeholder="Select Method"
                      @input="resetmodeError()"
                    >
                    </model-list-select>
                  </div>
                  <div class="text-danger" v-if="modeError">
                    <em>{{ modeError }}</em>
                  </div>
                </div>
                <div class="col-md-3" v-show="GeneralSettings.capture_purchase_invoiceno == 1">
                  <div class="form-group">
                    <label>Invoice No.</label>
                    <input
                      type="text"
                      class="form-control"
                      v-model="totals.invoice"
                    />
                  </div>
                </div>
                <div class="col-md-4 mt-2">
                  <div class="form-group">
                    <label>Supplier </label>
                    <model-list-select
                      :list="Suppliers ? Suppliers : []"
                      v-model="totals.supplier"
                      option-value="id"
                      option-text="name"
                      placeholder="Select Supplier"
                    >
                    </model-list-select>
                  </div>
                  <div class="text-danger" v-if="supplierError">
                    <em>{{ supplierError }}</em>
                  </div>
                </div>

                <div class="col-md-4 mt-2">
                  <label>
                    Select Factory
                    <b-button size="sm" variant="link" v-b-modal.add-factory-modal>
                      New Factory
                    </b-button>
                  </label>

                  <model-list-select :list="formattedFactories" v-model="totals.factory" option-value="id"
                    option-text="display_name" placeholder="Select Factory">
                  </model-list-select>
                </div>

                <div class="form-group col-md-4 mt-2">
                  <label>Date <span class="text-danger">*</span></label>
                  <input
                      type="date"
                      class="form-control"
                      v-model="totals.date"
                      placeholder="Enter Date"
                      v-limit-future-date
                  />
                </div>
                <div class="form-group col-md-4">
                  <label>Delivery Car Plate No.</label>
                  <input
                      type="text"
                      class="form-control"
                      v-model="totals.car_plate_no"
                      placeholder="Enter Plate No."
                  />
                </div>
                <div v-if="MyUserPerm.stocking_consumables== 1 && SaveStatus && branchid != 0" class="col-md-4 mt-4">
                  <b-button variant="primary" class="pull-center" disabled
                  ><i class="fa fa-check"></i> Save & Exit
                    <b-spinner
                        variant="light"
                        label="Spinning"
                    ></b-spinner>
                  </b-button>
                </div>
                <div v-if="MyUserPerm.stocking_consumables== 1 && !SaveStatus && branchid != 0" class="col-md-4 mt-4">
                  <b-button variant="primary" class="pull-center" @click="saveStock()"
                  ><i class="fa fa-check"></i> Save & Exit
                  </b-button>
                </div>
                
                <!-- Print payment voucher -->
                <div v-if="MyUserPerm.stocking_consumables== 1 && SaveStatus && branchid != 0" class="col-md-4 mt-4">
                  <b-button variant="primary" class="pull-center" disabled
                  ><i class="fa fa-check"></i> Save & Print
                    <b-spinner
                        variant="light"
                        label="Spinning"
                    ></b-spinner>
                  </b-button>
                </div>
                <div v-if="MyUserPerm.stocking_consumables== 1 && !SaveStatus && branchid != 0" class="col-md-4 mt-4">
                  <b-button variant="primary" class="pull-center" @click="saveStockPrint()"
                  ><i class="fa fa-check"></i> Save & Print
                  </b-button>
                </div>
              </div>
            </b-form>
          </div>
        </div>
      </div>

      <div class="col-md-4">
        <div class="card">
          <div class="card-body">
            <form action="">

              <div class="form-group mb-3">
                <label>Product <span class="text-danger">*</span></label>
                <model-list-select
                    :list="Consumables ? Consumables : []"
                    v-model="data.product"
                    option-value="id"
                    option-text="nameto_select"
                    placeholder="Select Product"
                    @input="resetErrors(), checkItem(), assignArr()"
                >
                </model-list-select>
                <div class="text-danger" v-if="itemError">
                  <em>{{ itemError }}</em>
                </div>
              </div>
              <div class="form-group mb-3">
                  <label>Unit Measure <span class="text-danger">*</span></label>
                  <model-list-select
                  :list="unitsArr ? unitsArr : []"
                  v-model="data.unit"
                  option-value="id"
                  option-text="unitsym"
                  placeholder="Select Unit"
                  @input="resetErrors(), assignUnitPrices()"
                  >
                  </model-list-select>
                  <div class="text-danger" v-if="unitError">
                  <em>{{ unitError }}</em>
                  </div>
              </div>
              <div class="row">
                  <div class="form-group mb-3">
                    <label>Quantity <span class="text-danger">*</span></label>
                    <input
                        type="number"
                        class="form-control"
                        step="any"
                        v-model="data.quantity"
                        @input="resetErrors()"
                        placeholder="Enter Quantity"
                    />
                    <div class="text-danger" v-if="quantityError">
                      <em>{{ quantityError }}</em>
                    </div>
                  </div>
              </div>
              <div class="form-group mb-3">
                <label>Unit Price <span class="text-danger">*</span></label>
                <input
                    type="text"
                    class="form-control"
                    step="any"
                    v-model="data.unit_price"
                    @input="resetErrors(),addPriceCommas()"
                    placeholder="Enter Unit Price"
                />
                <div class="text-danger" v-if="priceError">
                  <em>{{ priceError }}</em>
                </div>
              </div>
              <div v-if="GeneralSettings.track_expiries == 1" class="form-group mb-3">
                <label>Batch Number <span v-if="data.expiry !='' " class="text-danger">*</span></label>
                <input
                  type="text"
                  class="form-control"
                  v-model="data.batch"
                  @input="resetErrors()"
                  placeholder="Enter Batch Number"
                  @keyup.enter="addToCart()"
                />
                <div class="text-danger" v-if="batch_noError">
                  <em>{{ batch_noError }}</em>
                </div>
              </div>
              <div v-if="GeneralSettings.track_expiries == 1" class="form-group mb-3">
                <label>Expiry Date <span v-if="data.batch !='' " class="text-danger">*</span></label>
                <input
                  type="date"
                  class="form-control"
                  v-model="data.expiry"
                  @input="resetErrors()"
                  @keyup.enter="addToCart()"
                />
                <div class="text-danger" v-if="expiry_dateError">
                  <em>{{ expiry_dateError }}</em>
                </div>
              </div>
              <div class="form-group text-center" v-if="branchid != 0">
                <b-button
                    @click="addToCart()"
                    variant="primary"
                ><i class="fa fa-plus"></i> Add
                  <b-spinner
                      v-if="SaveStatus"
                      variant="light"
                      small
                      label="Spinning"
                  ></b-spinner>
                </b-button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>

    <!-- Factory modal starts -->
    <b-modal id="add-factory-modal" hide-footer @hidden="resetFactory">
      <template #modal-title> Add Factory </template>

      <div class="form-group mb-3">
        <label>Factory Name <span class="text-danger">*</span></label>
        <div class="input-group">
          <input type="text" placeholder="Enter Name " class="form-control" @input="resetErrors()"
            v-model="factorydata.name" />
        </div>
        <div class="text-danger" v-if="nameError">
          <em>{{ nameError }}</em>
        </div>
      </div>

      <div class="form-group mb-3">
        <label>Factory Contact</label>
        <div class="input-group">
          <input type="number" placeholder="Enter Factory Contact" class="form-control" v-model="factorydata.contact"
            @input="resetErrors()" />
        </div>
        <div class="text-danger" v-if="contactError">
          <em>{{ contactError }}</em>
        </div>
      </div>

      <div class="form-group mb-3">
        <label>Factory Location</label>
        <div class="input-group">
          <input type="text" placeholder="Enter Factory Location" class="form-control" v-model="factorydata.location" />
        </div>
      </div>

      <div class="modal-footer">
        <button type="button" class="btn btn-danger" data-dismiss="modal" @click="closeModal('add-factory-modal')">
          <i class="fa fa-times"></i> Close
        </button>
        <button v-if="SaveStatus" type="button" class="btn btn-primary"> <i class="fa fa-check"></i>
          Submit
          <b-spinner disabled variant="light" small label="Spinning"></b-spinner>
        </button>
        <button v-else type="button" class="btn btn-primary" @click="addFactory('add-factory-modal')"> <i
            class="fa fa-check"></i>
          Submit
        </button>
      </div>
    </b-modal>
    <!-- modal ends -->

    <!-- modal edit item starts -->
    <b-modal id="edit-item-modal" class="text-primary" hide-footer @hidden="resetEdit()">
      <template #modal-title>
        Edit Item {{ editdata.name }}</template
      >
      <div class="form-group mb-3">
        <label>Quantity</label>
        <input
            type="number"
            class="form-control"
            step="any"
            v-model="editdata.quantity"
        />
      </div>
      <div class="form-group mb-3">
        <label>Unit Price</label>
        <input type="text" class="form-control" step="any" v-model="editdata.unit_price" @input="editPriceCommas()"/>
      </div>
      <div class="form-group mb-3">
        <label>Batch Number</label>
        <input type="text" class="form-control" v-model="editdata.batch" />
      </div>
      <div class="form-group mb-3">
        <label>Expiry Date</label>
        <input type="date" class="form-control" v-model="editdata.expiry" />
      </div>
      <div class="modal-footer">
        <button
            type="button"
            class="btn btn-danger"
            data-dismiss="modal"
            @click="closeModal('edit-item-modal')"
        >
          <i class="fa fa-times"></i> Close
        </button>
        <button
            type="button"
            class="btn btn-primary"
            @click="editItem('edit-item-modal')"
        >
          <i class="fa fa-check"></i> Save Changes
          <b-spinner
              v-if="SaveStatus"
              variant="light"
              small
              label="Deleting"
          ></b-spinner>
        </button>
      </div>
    </b-modal>
    <!-- modal ends -->
    <!-- modal delete expense starts -->
    <b-modal id="delete-item-modal" class="text-danger" hide-footer @hidden="resetDeleteItem">
      <template #modal-title> Delete {{ deletedata.name }}</template>
      <div class="form-group mb-3">
        <div class="input-group">
          <h5>Do you want to remove this item? Click Proceed to continue.</h5>
        </div>
      </div>
      <div class="modal-footer">
        <button
            type="button"
            class="btn btn-secondary"
            data-dismiss="modal"
            @click="closeModal('delete-item-modal')"
        >
          <i class="fa fa-times"></i> Close
        </button>
        <button
            type="button"
            class="btn btn-danger"
            @click="deleteItem('delete-item-modal')"
        >
          <i class="fa fa-trash"></i> Proceed
          <b-spinner
              v-if="SaveStatus"
              variant="light"
              small
              label="Deleting"
          ></b-spinner>
        </button>
      </div>
    </b-modal>
    <!-- modal ends -->
    <!--  end row -->
  </Layout>
</template>
<style>
.btn-primary, .page-link { background-color:#FAB031 !important;border-color:#FAB031 !important;}
</style>